import { OutOfContextOperation, RequestOperation, RequestOperationRequest } from "@peercolab/engine";

// TypeScript types converted from C# records
export type ChatInstruction = {
    // Valid types: message
    type: string;
    // Valid types: user, assistant, system, developer
    role: string;
    content: string;
};

export type ProcessChatInstructionInput = {
    usageInstructions: string;
    currentStateSnapshot: string;
    items: ChatInstruction[];
};

export type ProcessChatInstructionOutput = {
    message?: string;
    operations: OutOfContextOperation[];
};

export class ProcessChatInstruction extends RequestOperation<ProcessChatInstructionInput, ProcessChatInstructionOutput> {
    constructor() {
        super(
            "PeerColab.Instructions.ProcessChatInstruction",
            "PROCESS",
            [],
            { requiresTenant: true, characterSetup: { } }
        );
    }
}

export class PeerColabAI {
  public static processChatInstructions(input: ProcessChatInstructionInput): RequestOperationRequest<ProcessChatInstructionInput, ProcessChatInstructionOutput> {
    const operation = new ProcessChatInstruction();
    return new RequestOperationRequest<ProcessChatInstructionInput, ProcessChatInstructionOutput>(
      'PeerColab.Instructions',
      {
        type: operation.type,
        id: operation.id,
        verb: operation.verb,
        pathParameters: operation.pathParameters,
        settings: operation.settings
      },
      input
    );
  }
}